import React from 'react';
import AugmentedRealityViewer from 'src/components/augmentedRealityViewer/augmentedRealityViewer';
import AugmentedRealityViewerLayout from 'src/components/augmentedRealityViewer/augmentedRealityViewer-layout';


const AugmentedReadlityViewerPage: React.FC = () => {
  return (
    <AugmentedRealityViewerLayout children={<AugmentedRealityViewer/>}></AugmentedRealityViewerLayout>
  );
};

export default AugmentedReadlityViewerPage;